<template>
    <Dialog v-model:open="opened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent class="max-w-6xl">
            <DialogHeader> </DialogHeader>

            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead> {{ $t("domains.type") }} </TableHead>
                        <TableHead>{{ $t("domains.name") }} </TableHead>
                        <TableHead>{{ $t("domains.value") }} </TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow v-for="(record, i) of records" :key="i">
                        <TableCell class="font-medium">
                            {{ record.type }}
                        </TableCell>
                        <TableCellWithCopy
                            :show-value-as-kbd="true"
                            :value="record.name"
                        />
                        <TableCellWithCopy
                            :show-value-as-kbd="true"
                            :value="record.value"
                        />
                    </TableRow>
                </TableBody>
            </Table>
            <DialogFooter>
                <a
                    :href="
                        route('app.domains.downloads.dns', {
                            domain: domain.id,
                        })
                    "
                    class="relative ml-2 inline-flex items-center gap-1 rounded-l-md rounded-r-md bg-white px-3 py-2 text-sm font-medium text-iron-900 ring-1 ring-inset ring-iron-300 hover:bg-iron-50 focus:z-10"
                >
                    <ArrowDownToLine :stroke-width="1.6" :size="20" />
                    <span class="hidden sm:inline-block">{{
                        $t("domains.download")
                    }}</span>
                </a>
                <Button @click="opened = false"> {{ $t("close") }}</Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTrigger,
} from "@/components/ui/dialog";
import route from "ziggy-js";
import axios from "axios";
import { ref, onMounted } from "vue";

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
    TableCellWithCopy,
} from "@/components/ui/table";

type DomainRecord = {
    type: "CNAME" | "TXT";
    name: string;
    value: string;
};

const opened = ref(false);
const records = ref<DomainRecord[]>([]);

const props = defineProps<{
    domain: any;
}>();

async function getDomainRecords() {
    const res = await axios.get(
        route("app.domains.show", { domain: props.domain.id }),
    );

    records.value = res.data.data;
}

onMounted(async () => {
    await getDomainRecords();
});
</script>
